import './subscribe.scss';

export default () => {

};
